import React from "react";

function Innerbanner({ name, title }) {
  return (
    <div className="main-section-inner">
      <div className="main-section-inner bg-[#95D8D166] h-[25vh]  flex flex-col items-center justify-center">
        <h1 className="text-center text-black-600 p-3 border-rounded  rounded-lg font-custom bg-[#95D8D1]">
          {title}
        </h1>
        <h3 className="text-center text-5xl font-semibold mb-4 text-gray-900 font-custom mt-5">
          {name}
        </h3>
      </div>
    </div>
  );
}

export default Innerbanner;
